module.exports = __webpack_public_path__ + "static/media/18ECA48.a105f35f.jpg";